import { Component, inject } from '@angular/core';
import { VendorsModule } from "../../../../../vendors/src/lib/vendors.module";
import { AuthApiEnum } from '../../@application/enums/auth-api.enum';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiBaseService } from '../../../../../vendors/src/lib/services/api-base.service';
import { AuthPathEnum } from '../../@application/enums/auth-path.enum';


@Component({
    selector: 'lib-forget-verify',
    imports: [
    RouterLink,
    VendorsModule,
    ReactiveFormsModule,
    FormsModule
],
    templateUrl: './forget-verify.component.html',
    styleUrl: './forget-verify.component.css'
})
export class ForgetVerifyComponent {
  forgetVerifyForm!: FormGroup;
  passwordVisible = false;
  rememberMe = false;
  confirmPassword = new FormControl()
  confirmPasswordVisible = false;
  apiBaseService = inject(ApiBaseService)
  router = inject(Router)

  ngOnInit(): void {
    this.formInitializer()
  }

  private formInitializer(): void {
    this.confirmPassword = new FormControl(null, [Validators.required, this.confirmationValidator])
    this.forgetVerifyForm = new FormGroup({
      mobileNumber: new FormControl(null, [Validators.required]),
      otp: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    })
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.forgetVerifyForm.controls['password'].value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  submitForm() {
    if (this.forgetVerifyForm.valid) {
      this.apiBaseService.POST_API([AuthApiEnum.Auth, AuthApiEnum.Password, AuthApiEnum.ForgetVerify],
        this.forgetVerifyForm.value)
        .subscribe({
          next: value => {
            this.router.navigate([AuthPathEnum.Auth])
          },
          error: err => {
            // Handle error if needed
          }
        })
    } else {
      Object.values(this.forgetVerifyForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({onlySelf: true})
        }
      })
    }
  }
}
